import React, { Component } from 'react';
import Link from '../../../Elements/link';
import PlanningItemService from '../../../Services/PlanningItemService.js';
import PIMultiEditBox from './PIMultiEditBox';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import { Paper } from '@mui/material';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import PIMAssStatusUpdate from './PIMAssStatusUpdate';
import PIAddNewFieldworkPeriods from './PIAddNewFieldworkPeriods';
import ButtonRow from '../../../Elements/ButtonRow';
import InfoBox from '../../../Elements/InfoBox';
import PlanningItem from '../../../Domain/PlanningItem';
import ErrorMessage from '../../../Elements/ErrorMessage';
import PlanningMain from '../PlanningMain';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import PlanningSearchParams from './PlanningSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

class PlanningList extends Component
{
  myTimeOut = null;

  constructor (props)
  {
    super(props);

    this.state = {
      serviceId: props.serviceId,
      searchItem: new PlanningSearchParams(),
      planningItemsList: [],
      offices: [],
      loading: false,
      orderBy: 'PlanningId',
      orderDirection: 'Asc',
      shownPanel: ShownPanelsEnum.None,
      searchParams: {
        PlanningId: '',
        CountryName: '',
        PricingOfficeName: ''
      }
    };
    this.showPanel = this.showPanel.bind(this);
    this.submitAddNewFieldworkPeriods = this.submitAddNewFieldworkPeriods.bind(this);
    this.refresh = this.refresh.bind(this);
    this.multipleStatusEdit = this.multipleStatusEdit.bind(this);
    PlanningItem.clickOnSelect = this.clickOnSelect.bind(this);
    PlanningItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    PlanningItem.selectedStatus = this.selectedStatus.bind(this);
  }

  componentWillUnmount ()
  {
    clearTimeout(this.myTimeOut);
  }

  selectAllElements ()
  {
    const selectedStatus = this.state.planningItemsList.some((item) => item.Selected === false);
    const templist = [ ...this.state.planningItemsList ];

    if (templist !== undefined && templist.length > 0)
    {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ planningItemsList: templist });
  }

  selectedStatus ()
  {
    if (this.state.planningItemsList.some((x) => x.Selected === false))
    {
      return false;
    }
    return true;
  }

  clickOnSelect (item, selected)
  {
    item.Selected = !item.Selected;
    const tempList = [ ...this.state.planningItemsList ];
    if (tempList !== undefined)
    {
      this.setState({ planningItemsList: tempList });
    }
  }

  refresh ()
  {
    this.setState({ searchItem: { ...this.setState.searchItem } });
  }

  async editMultiplePlanningItemList (applyDateRow, newStartDates, newEndDates, subpanelValues)
  {
    const editedPlanningItems = this.state.planningItemsList.filter(
      (item) =>
        item.Selected &&
        item.PlanningId.toString().includes(this.state.searchParams.PlanningId) &&
        item.CountryName.toString()
          .toLowerCase()
          .includes(this.state.searchParams.CountryName.toString().toLowerCase()) &&
        item.PricingOfficeName.includes(this.state.searchParams.PricingOfficeName)
    );

    if (editedPlanningItems.length > 0)
    {
      PlanningDetailsItemService.EditMultiplePlanningDetailItemsByPricingIds(
        editedPlanningItems,
        applyDateRow,
        newStartDates,
        newEndDates,
        subpanelValues
      )
        .then(() =>
        {
          this.setState({ shownPanel: ShownPanelsEnum.None });
          ErrorMessage.SetNotification('Update is ready.');
        })
        .catch(() => ErrorMessage.SetErrorMessage('PL125'));
    }
  }

  submitMassStatusUpdate (applyDateRow, newStatus)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: true
    });
    this.multipleStatusEdit(applyDateRow, newStatus);
  }

  multipleStatusEdit (applyDateRow, newStatus)
  {
    const editedPlanningItems = this.state.planningItemsList.filter(
      (item) =>
        item.Selected &&
        item.PlanningId.toString().includes(this.state.searchParams.PlanningId) &&
        item.CountryName.toString()
          .toLowerCase()
          .includes(this.state.searchParams.CountryName.toString().toLowerCase()) &&
        item.PricingOfficeName.includes(this.state.searchParams.PricingOfficeName)
    );

    if (editedPlanningItems.length > 0)
    {
      PlanningDetailsItemService.UpdateMultiplePlanningDetailItemStatusByPricingIds(
        editedPlanningItems,
        applyDateRow,
        newStatus
      )
        .then(() => this.setState({ searchItem: { ...this.state.searchItem } }))
        .catch(() => ErrorMessage.SetErrorMessage('PL143'));
    }
  }

  submitAddNewFieldworkPeriods (NumberOfNewFieldworkPeriods)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: true
    });

    const editedPlanningItems = this.state.planningItemsList.filter(
      (item) =>
        item.Selected &&
        item.PlanningId.toString().includes(this.state.searchParams.PlanningId) &&
        item.CountryName.toString()
          .toLowerCase()
          .includes(this.state.searchParams.CountryName.toString().toLowerCase()) &&
        item.PricingOfficeName.includes(this.state.searchParams.PricingOfficeName)
    );

    if (editedPlanningItems.length > 0)
    {
      PlanningDetailsItemService.AddNewPlanningDetailItemsByPricingIds(
        editedPlanningItems,
        NumberOfNewFieldworkPeriods
      ).then(() =>
      {
        ErrorMessage.SetSuccess(
          'The new PlanningDetail Items have been created. You will see them after the next refreshing (within an hour).'
        );
        this.setState({ searchItem: { ...this.state.searchItem } });
      });
    }
  }

  renderInfoRow ()
  {
    const first = this.state.planningItemsList[ 0 ];
    if (!first) return null;
    const itemsUderRefreshing = this.state.planningItemsList.filter((pi) => pi.UpcomingChanges > 0);
    const actualMinute = new Date().getMinutes();
    if (itemsUderRefreshing.length > 0)
    {
      this.myTimeOut = window.setTimeout(this.refresh, 60000);
    }

    return (
      <Paper elevation={6} className='border p-1 m-1'>
        <div className='d-flex justify-content-between'>
          <div>
            <p className='inforow'>
              Client: {first.ClientName} ({first.ClientId}), Industry: {first.ClientIndustry}, Office:{' '}
              {first.ClientOfficeName}
            </p>
            <p className='inforow'>
              Opportunity: {first.OpportunityName} ({first.OpportunityId}), Office: {first.OpportunityOfficeName}
            </p>
            <p className='inforow'>
              Service: {first.ServiceName} ({first.ServiceId}), Number of cycles per year: {first.NumCyclesPerYear},
              Age: {first.ServiceAge}
            </p>
          </div>
          {itemsUderRefreshing.length > 0 ? (
            <div className='m-1'>
              <InfoBox
                title='Warning!'
                text={`Some of the following plannings are waiting for refreshing. The next refreshing will run within an hour. (Approx.: ${65 -
                  actualMinute} min.)`}
                rotated='+'
              />
            </div>
          ) : null}
        </div>
      </Paper>
    );
  }

  renderLinkRow ()
  {
    return (
      <Paper className='border p-1 m-1' elevation={6}>
        <Link
          linktext={`Planning - Services (${this.state.serviceId})`}
          title='Planning - Services'
          link={<PlanningMain />}
          className='linkrowlink'
          iconName='fa-solid fa-ruler-combined'
          url='planning'
        />
      </Paper>
    );
  }

  showPanel (panelName)
  {
    if (panelName === ShownPanelsEnum.Refresh)
    {
      this.refresh();
      panelName = ShownPanelsEnum.None;
    }
    const newShownPanel = panelName === this.state.shownPanel ? ShownPanelsEnum.None : panelName;
    this.setState({
      shownPanel: newShownPanel
    });
  }

  maxNumberOfEvalsPerCycle ()
  {
    return Math.max(...this.state.planningItemsList.map((item) => item.NumberOfEvalsPerCycle));
  }

  maxNumberOfPlanningDetails ()
  {
    return Math.max(...this.state.planningItemsList.map((item) => item.NumberOfPlanningDetails));
  }

  renderMultiEditPanel ()
  {
    return (
      <PIMultiEditBox
        numberOfEvalsPerCycle={this.maxNumberOfEvalsPerCycle()}
        numberOfPlanningDetails={this.maxNumberOfPlanningDetails()}
        selectedCountries={this.getSelectedCountriesWithAssignmentNumbers()}
        submitHandler={(applyDateRow, startDates, endDates, subpanelValues) =>
        {
          this.editMultiplePlanningItemList(applyDateRow, startDates, endDates, subpanelValues);
        }}
        clickOnCancel={() => this.showPanel(ShownPanelsEnum.None)}
      />
    );
  }

  renderMassStatusUpdate ()
  {
    return (
      <PIMAssStatusUpdate
        numberOfEvalsPerCycle={this.maxNumberOfEvalsPerCycle()}
        numberOfPlanningDetails={this.maxNumberOfPlanningDetails()}
        countries={this.getSelectedCountries()}
        submitHandler={(applyDateRow, newStatus) => this.submitMassStatusUpdate(applyDateRow, newStatus)}
        clickOnCancel={() => this.showPanel(ShownPanelsEnum.None)}
      />
    );
  }

  getSelectedCountries ()
  {
    const selectedPlanningItems = this.state.planningItemsList.filter(
      (item) =>
        item.Selected &&
        item.PlanningId.toString().includes(this.state.searchParams.PlanningId) &&
        item.CountryName.toString()
          .toLowerCase()
          .includes(this.state.searchParams.CountryName.toString().toLowerCase()) &&
        item.PricingOfficeName.includes(this.state.searchParams.PricingOfficeName)
    );
    const countries = [];
    selectedPlanningItems.forEach((item) => countries.push(item.CountryName));

    return countries;
  }

  getSelectedCountriesWithAssignmentNumbers ()
  {
    const selectedPlanningItems = this.state.planningItemsList.filter(
      (item) =>
        item.Selected &&
        item.PlanningId.toString().includes(this.state.searchParams.PlanningId) &&
        item.CountryName.toString()
          .toLowerCase()
          .includes(this.state.searchParams.CountryName.toString().toLowerCase()) &&
        item.PricingOfficeName.includes(this.state.searchParams.PricingOfficeName)
    );
    const countriesWithNumbers = [];
    selectedPlanningItems.forEach((item) =>
    {
      countriesWithNumbers.push({
        pricingId: item.PricingId,
        country: item.CountryName,
        numberOfContractedAssignments: Math.floor(item.NumberOfContractedAssignments / item.NumberOfPlanningDetails),
        numberOfPlannedAssignments: Math.floor(item.NumberOfPlannedAssignments / item.NumberOfPlanningDetails),
        startDate: item.OpportunityActualStartOn,
        endDate: item.OpportunityActualEndOn
      });
    });
    return countriesWithNumbers;
  }

  renderAddNewFieldworkPeriods ()
  {
    return (
      <PIAddNewFieldworkPeriods
        numberOfEvalsPerCycle={this.maxNumberOfEvalsPerCycle()}
        numberOfPlanningDetails={this.maxNumberOfPlanningDetails()}
        countries={this.getSelectedCountries()}
        submitHandler={this.submitAddNewFieldworkPeriods}
        clickOnCancel={() => this.showPanel(ShownPanelsEnum.None)}
      />
    );
  }

  renderButtonRow ()
  {
    return (
      <ButtonRow
        colors={[ ButtonColorsEnum.Secondary, ButtonColorsEnum.Secondary, ButtonColorsEnum.Primary ]}
        labels={[ 'Multi Edit', 'STATUS UPDATE', 'ADD FW PERIOD' ]}
        keys={[ ShownPanelsEnum.MultiEdit, ShownPanelsEnum.MassStatusUpdate, ShownPanelsEnum.AddNewItem ]}
        icons={[ 'fa-solid fa-edit', 'fa-solid fa-pen-alt', 'fa-solid fa-plus-circle' ]}
        value={this.state.shownPanel}
        onClick={this.showPanel}
        roleKeys={[ 'user_key', 'user_key', 'user_key' ]}
      />
    );
  }

  renderPanels ()
  {
    return (
      <div>
        {this.renderButtonRow()}
        {this.state.shownPanel === ShownPanelsEnum.MultiEdit && this.renderMultiEditPanel()}
        {this.state.shownPanel === ShownPanelsEnum.MassStatusUpdate && this.renderMassStatusUpdate()}
        {this.state.shownPanel === ShownPanelsEnum.AddNewItem && this.renderAddNewFieldworkPeriods()}
      </div>
    );
  }

  render ()
  {
    return (
      <div key='planninglistdiv' className='contentwrapper'>
        {this.renderLinkRow()}
        {this.renderInfoRow()}
        {this.renderPanels()}
        <TabOfDataTable
          type={PlanningItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={PlanningItemService.GetPlanningItemsByServiceId}
          convertDBItemsFunction={PlanningItemService.ConvertDBPlanningItems}
          showSearchStrip={true}
          searchItem={this.state.searchItem}
          itemList={this.state.planningItemsList}
          isFilterDisabled={true}
          changeOfItemListFunction={(itemList) => this.setState({ planningItemsList: itemList })}
          errorCode='PL347'
        />
      </div>
    );
  }
}

export default PlanningList;
